import React, { useEffect, useRef } from 'react'
import { useInfiniteHits } from 'react-instantsearch'
import { ExpertsList } from 'components/ExpertsList'

export type ExpertHit = {
  id: string
  profileName: string
  profileImageUrl: string
  profileImageAlt: string
  jobTitle: string
  location: string
  legacyExpertId: number
  headShotImageUrl: string
  isTopExpert?: boolean
}

export const ExpertHits = (props) => {
  const { hits, isLastPage, showMore } = useInfiniteHits<ExpertHit>(props)
  const sentinelRef = useRef(null)

  useEffect(() => {
    let observer: IntersectionObserver | undefined
    if (sentinelRef.current !== null) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLastPage) {
            showMore?.()
          }
        })
      })

      observer?.observe(sentinelRef.current)
    }

    return () => {
      observer?.disconnect()
    }
  }, [isLastPage, showMore])

  return (
    <>
      <ExpertsList
        isWithLoading={false}
        route="/search"
        isSearchPage
        experts={hits.map((hit) => ({
          id: hit.legacyExpertId,
          slug: hit.id,
          profileName: hit.profileName,
          jobTitle: hit.jobTitle,
          profileImageAttachment: {
            url: hit.profileImageUrl,
            alt: hit.profileName,
          },
          isTopExpert: hit.isTopExpert,
          location: hit.location,
        }))}
      />
      <div ref={sentinelRef} aria-hidden="true" />
    </>
  )
}
